module.exports = __webpack_public_path__ + "assets/img/white-customer-4.48db0352.png";